import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Scale01 = function Scale01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14 22H6.8m0 0c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2M6.8 22h.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C12 19.7202 12 18.8802 12 17.2v-.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C9.7202 12 8.8802 12 7.2 12h-.4c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 14.2798 2 15.1198 2 16.8v.4m0 0V10m8-8h4m8 8v4m-4 8c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C22 19.395 22 18.93 22 18m0-12c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C19.395 2 18.93 2 18 2M6 2c-.93 0-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C2 4.605 2 5.07 2 6"
    })
  }));
};
export default Scale01;